import styled, { css } from 'styled-components';
import Icon from '@nubank/nuds-web/components/Icon/Icon';
import { breakpointsMedia } from '@nubank/nuds-web/styles/breakpoints';

export const StyledIcon = styled(Icon)`
  ${breakpointsMedia({
    xs: css`transform: translate3d(0,0.125rem,0);`,
    md: css`transform: translate3d(0,0.5rem,0);`,
  })}
`;

StyledIcon.displayName = 'StyledIcon';
